module.exports = __webpack_public_path__ + "resources/2.1.0/media/logo-qobuz-large.25427bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/logo-qobuz-large.png
// module id = 962
// module chunks = 0